'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.filterAttrs = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _actions = require('../actions');

var _actions2 = _interopRequireDefault(_actions);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _lodash = require('lodash');

var _UIButton = require('UIComponents/button/UIButton');

var _UIButton2 = _interopRequireDefault(_UIButton);

var _UIForm = require('UIComponents/form/UIForm');

var _UIForm2 = _interopRequireDefault(_UIForm);

var _UIFormControl = require('UIComponents/form/UIFormControl');

var _UIFormControl2 = _interopRequireDefault(_UIFormControl);

var _UITextArea = require('UIComponents/input/UITextArea');

var _UITextArea2 = _interopRequireDefault(_UITextArea);

var _UITextInput = require('UIComponents/input/UITextInput');

var _UITextInput2 = _interopRequireDefault(_UITextInput);

var _UIFixedSaveBar = require('UIComponents/panel/UIFixedSaveBar');

var _UIFixedSaveBar2 = _interopRequireDefault(_UIFixedSaveBar);

var _UIToggle = require('UIComponents/input/UIToggle');

var _UIToggle2 = _interopRequireDefault(_UIToggle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ATTRS = {
  firstName: { type: 'text', layout: 1, label: 'First Name', required: true },
  lastName: { type: 'text', layout: 2, label: 'Last Name', required: true },
  linkedInUrl: { type: 'text', layout: 3, label: 'LinkedIn Link', link: true, domain: 'linkedin.com' },
  googleUrl: { type: 'text', layout: 4, label: 'GooglePlus Link', link: true, domain: 'google.com' },
  facebookUrl: { type: 'text', layout: 5, label: 'Facebook Link', link: true, domain: 'facebook.com' },
  location: { type: 'text', layout: 6, label: 'Location' },
  jobTitle: { type: 'text', layout: 7, label: 'Title' },
  company: { type: 'text', layout: 8, label: 'Company' },
  companyWebsite: { type: 'text', layout: 9, label: 'Company website', link: true },
  website: { type: 'text', layout: 10, label: 'Personal website', link: true },
  bio: { type: 'text', layout: 11, label: 'Bio', area: true },
  published: { type: 'boolean', label: 'Published' }
};

var ATTR_LAYOUT = Object.keys(ATTRS).filter(function (attr) {
  return ATTRS[attr].layout;
}).sort(function (a, b) {
  return ATTRS[a].layout - ATTRS[b].layout;
});

var hasDomainError = function hasDomainError(val, domain) {
  return !((val || '').split('//').pop().split('/')[0] || domain).endsWith(domain);
};

var massagedChange = function massagedChange(attr, val) {
  var massaged = val && attr !== 'published' && val.trim() || val;
  if (ATTRS[attr].link && massaged) {
    massaged = 'https://' + (val || '').split('//').pop();
  }
  return _defineProperty({}, attr, massaged);
};

var UserEdit = function (_Component) {
  _inherits(UserEdit, _Component);

  function UserEdit(props) {
    _classCallCheck(this, UserEdit);

    var _this = _possibleConstructorReturn(this, (UserEdit.__proto__ || Object.getPrototypeOf(UserEdit)).call(this, props));

    _this.submit = _this.submit.bind(_this);

    _this.changes = {};

    var _loop = function _loop(attr) {
      _this.changes[attr] = (0, _lodash.debounce)(function (val) {
        return _this.props.edit(massagedChange(attr, val));
      }, 200);
    };

    for (var attr in ATTRS) {
      _loop(attr);
    }
    return _this;
  }

  _createClass(UserEdit, [{
    key: 'hasErrors',
    value: function hasErrors() {
      for (var attr in ATTRS) {
        if (ATTRS[attr].domain) {
          if (hasDomainError(this.props.user[attr], ATTRS[attr].domain)) {
            return true;
          }
        }
      }
      return false;
    }
  }, {
    key: 'submit',
    value: function submit(evt) {
      evt.preventDefault();
      this.props.save(this.props.user);
    }
  }, {
    key: 'renderTextInput',
    value: function renderTextInput(attr) {
      var _this2 = this;

      var opts = ATTRS[attr];
      var val = this.props.user[attr];
      var props = {
        use: 'on-dark',
        defaultValue: val || '',
        onChange: function onChange(evt) {
          return _this2.changes[attr](evt.target.value);
        },
        error: opts.domain ? hasDomainError(val, opts.domain) : false
      };
      return _react2.default.createElement(
        _UIFormControl2.default,
        { label: opts.label, required: !!opts.required, key: attr },
        opts.area ? _react2.default.createElement(_UITextArea2.default, props) : _react2.default.createElement(_UITextInput2.default, props)
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      return _react2.default.createElement(
        _UIForm2.default,
        { onSubmit: this.submit },
        _react2.default.createElement(
          'div',
          { className: 'user-edit' },
          ATTR_LAYOUT.map(function (attr) {
            return _this3.renderTextInput(attr);
          }, this)
        ),
        _react2.default.createElement(
          'div',
          { className: 'publish' },
          _react2.default.createElement(_UIToggle2.default, {
            textChecked: 'Published',
            textUnchecked: 'Hidden',
            checked: this.props.user.published,
            onChange: function onChange(evt) {
              return _this3.changes.published(evt.target.checked);
            } })
        ),
        _react2.default.createElement(
          _UIFixedSaveBar2.default,
          null,
          _react2.default.createElement(
            _UIButton2.default,
            { type: 'submit', use: 'primary', disabled: this.hasErrors(), onClick: this.submit },
            'Save'
          ),
          _react2.default.createElement(
            _UIButton2.default,
            { use: 'secondary', onClick: this.props.cancel },
            'Cancel'
          )
        )
      );
    }
  }]);

  return UserEdit;
}(_react.Component);

var mapStateToProps = function mapStateToProps(_ref2) {
  var user = _ref2.user;

  return { user: _extends({}, user.staged, { id: user.id }) };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, {
  edit: function edit(changes) {
    return (0, _actions.createAction)(_actions2.default.USER_EDIT, changes);
  },
  save: function save(submit) {
    return (0, _actions.createAction)(_actions2.default.USER_SAVE, submit);
  },
  cancel: function cancel() {
    return (0, _actions.createAction)(_actions2.default.USER_CANCEL);
  }
})(UserEdit);
var filterAttrs = exports.filterAttrs = function filterAttrs(user) {
  var retval = {};
  for (var attr in ATTRS) {
    retval[attr] = user[attr];
  }
  return retval;
};


//////////////////
// WEBPACK FOOTER
// ./js/components/UserEdit.js
// module id = 206
// module chunks = 171